import React, { useState, useEffect } from "react";
import { fetch } from "../../actions";
import { connect } from "react-redux";
import dayjs from "dayjs";
import { ModalPadrao, InputPadrao, LabelPadrao, DatePickerPadrao, CheckBoxPadrao, LoadingContainerPadrao, MoneyIcon, LegendaEntrega, HouseIcon } from "../../components/Base";
import { Popover, Menu, Tag } from "antd";
import TabelaPadrao from "../../components/TabelaPadrao";
import { useFetch } from "../../components/Hooks/Conexao";
import { BtnListar, BtnPadrao, BtnSair } from "../../components/Buttons";
import EntregaConsultaDetalhe from "./EntregaConsultaDetalhe";
import getCssVariable from "../../Utils/getCssVariable";

function EntregaConsulta({ visible, onCancel, ...props }) {
  const [filtros, setFiltros] = useState({ dtIni: dayjs(), dtFim: dayjs(), aberto: true, pagamentoPendente: true, finalizado: false });
  const [dados, listar, loading] = useFetch(() => props.fetch().post("/entrega/get", filtros));
  const [entregaId, setEntregaId] = useState();

  useEffect(() => {
    if (visible)
      listar();

  }, [visible]);

  const menu = <Menu>
    <Menu.Item>
      <CheckBoxPadrao checked={filtros.aberto} onChange={() => setFiltros({ ...filtros, aberto: !filtros.aberto })}>Aberto</CheckBoxPadrao>
    </Menu.Item>
    <Menu.Item>
      <CheckBoxPadrao checked={filtros.pagamentoPendente} onChange={() => setFiltros({ ...filtros, pagamentoPendente: !filtros.pagamentoPendente })}>Pagamento pendente</CheckBoxPadrao>
    </Menu.Item>
    <Menu.Item>
      <CheckBoxPadrao checked={filtros.finalizado} onChange={() => setFiltros({ ...filtros, finalizado: !filtros.finalizado })}>Finalizado</CheckBoxPadrao>
    </Menu.Item>
  </Menu>;

  return <>
    <ModalPadrao title="Entregas" visible={visible} onCancel={onCancel} footer={<BtnSair onClick={onCancel} />} width={window.innerWidth < 1200 ? window.innerWidth : 1200}>
      <LoadingContainerPadrao loading={loading}>
        <div style={{ display: "flex", width: "100%", alignItems: "flex-end" }}>
          <div style={{ width: "30%", marginRight: 10 }}>
            <LabelPadrao noMargin>Cliente</LabelPadrao>
            <InputPadrao onPressEnter={listar} placeholder="Pesquisar" value={filtros.txt} onChange={v => setFiltros({ ...filtros, txt: v.target.value })} />
          </div>
          <div style={{ width: "30%" }}>
            <LabelPadrao noMargin>Período</LabelPadrao>
            <div style={{ display: "flex", width: "100%" }}>
              <DatePickerPadrao value={filtros.dtIni} onChange={v => setFiltros({ ...filtros, dtIni: v })} style={{ marginRight: 10, width: "50%" }} />
              <DatePickerPadrao value={filtros.dtFim} onChange={v => setFiltros({ ...filtros, dtFim: v })} style={{ width: "50%" }} />
            </div>
          </div>
          <div style={{ margin: "0 10px" }}>
            <Popover content={menu} placement="bottom" >
              <BtnPadrao style={{ width: 120 }}>Tipo</BtnPadrao>
            </Popover>
          </div>
          <BtnListar onClick={listar} />
        </div>

        <div style={{ minHeight: "50vh" }}>
          <TabelaPadrao setEdit={v => setEntregaId(v.id)} columns={columns} data={dados} style={{ marginTop: 25 }} />
        </div>
        <Legendas onClick={status => listar(() => props.fetch().post("/entrega/get", { ...filtros, status }))} />
      </LoadingContainerPadrao>

    </ModalPadrao>
    <EntregaConsultaDetalhe id={entregaId} onOk={() => { setEntregaId(null); listar(); }} onCancel={() => setEntregaId(null)} />
  </>;
}

function Legendas({ onClick }) {
  return <Tag style={{ width: "100%", marginTop: 20, padding: 5, background: "transparent" }}>
    <div style={{ justifyContent: "center", }} className="flex-padrao">
      <LegendaEntrega status="PEN" onClick={onClick} />
      <LegendaEntrega status="SEP" onClick={onClick} />
      <LegendaEntrega status="LIB" onClick={onClick} />
      <LegendaEntrega status="ROT" onClick={onClick} />
      <LegendaEntrega status="ENT" onClick={onClick} />
      <LegendaEntrega status="CAN" onClick={onClick} />
    </div>
  </Tag>;
}

export default connect(null, { fetch })(EntregaConsulta);

const columns = [
  {
    Header: "Data",
    accessor: "data",
    tipo: "dthr"
  },
  {
    Header: "Número",
    accessor: "numero",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: props => {
      const original = props.row.original;
      const icon = props.row.original.entregaOutraEmpresa ? <HouseIcon title="Entrega de empresas diferentes" style={{ marginLeft: 5, marginTop: -2 }} /> : null;
      if (original.status === "PEN")
        return <span style={{ color: getCssVariable("--laranja-padrao"), fontWeight: "bold", display: "flex" }}>Pendente {icon} {original.isPagamentoPendente && <MoneyIcon title="Pagamento pendente" style={{ color: getCssVariable("--laranja-padrao"), marginLeft: 5, marginTop: -5 }} />}</span>;
      else if (original.status === "SEP")
        return <span style={{ color: getCssVariable("--azul-padrao"), fontWeight: "bold", display: "flex" }}>Separação {icon}</span>;
      else if (original.status === "LIB")
        return <span style={{ color: getCssVariable("--azul-escuro-padrao"), fontWeight: "bold", display: "flex" }}>Liberado {icon}</span>;
      else if (original.status === "ROT")
        return <span style={{ color: getCssVariable("--amarelo-padrao"), fontWeight: "bold", display: "flex" }}>Em rota {icon}</span>;
      else if (original.status === "ENT")
        return <span style={{ color: getCssVariable("--verde-padrao"), fontWeight: "bold", display: "flex" }}>Entregue {icon}</span>;
      else if (original.status === "CAN")
        return <span style={{ color: getCssVariable("--vermelho-padrao"), fontWeight: "bold", display: "flex" }}>Cancelado {icon}</span>;
    },
  },
  {
    Header: "Cliente",
    accessor: "cliente",
  },
  {
    Header: "Bairro",
    accessor: "bairro",
  },
  {
    Header: "Valor Líquido",
    accessor: "valorTotal",
    tipo: "rs",
  },
];